<template>
  <div>
    <PmwTopProgress :start="loading" :done="!loading" />

    <SidebarLayout2 :breadcrumb="breadcrumb" pageTitle="Editar tarifa">
      <template #sidebar>
        <!-- PAINEL AZUL -->
        <SidebarBlock class="sidebar-panel">
          <PmwParagraph weight="medium" class="sidebar-panel--text">
            {{ hotelName }}
          </PmwParagraph>
        </SidebarBlock>

        <!-- AÇÕES -->
        <SidebarBlock class="sidebar-actions">
          <PmwParagraph
            size="paragraph-80"
            weight="medium"
            class="sidebar-actions--title"
          >
            Ações da página
          </PmwParagraph>
          <!-- SALVAR -->
          <PmwButton
            :disabled="disableSave"
            tooltipText="Para salvar, preencha todos os valores do quarto editado"
            variation="blue-100"
            @click="saveRate"
          >
            Salvar
          </PmwButton>

          <!-- DESVINCULAR -->
          <PmwButton variation="red-100" @click="unlinkMasterRate">
            Desvincular Tarifa Master
          </PmwButton>

          <!-- VOLTAR SEM SALVAR -->
          <PmwButton
            variation="blue-100"
            layout="outline"
            @click="$router.push(`/hoteis/regras-tarifarias/${hotelId}`)"
          >
            Voltar sem salvar
          </PmwButton>
        </SidebarBlock>

        <!-- DICA -->
        <SidebarBlock class="sidebar-tip">
          <PmwParagraph
            size="paragraph-80"
            weight="medium"
            class="sidebar-tip--title"
          >
            Atenção:</PmwParagraph
          >
          <PmwParagraph>
            Esta tarifa está vinculada a uma tarifa master
            <router-link
              :to="`/tarifas-master/editar/${masterRate}`"
              target="_blank"
              class="sidebar-tip--link"
              >clique aqui</router-link
            >
            para visualizar todas as informações da tarifa.
          </PmwParagraph>
        </SidebarBlock>
      </template>
      <template #gap-before-content>
        <span class="warning">
          <PmwParagraph class="warning--text">
            <PmwParagraph weight="bold">ATENÇÃO:</PmwParagraph> Esta tarifa está
            vinculada a uma tarifa master
            <router-link
              :to="`/tarifas-master/editar/${masterRate}`"
              target="_blank"
              class="warning--text__link"
              >clique aqui</router-link
            >
            para visualizar todas as informações da tarifa.
          </PmwParagraph>
        </span>
      </template>
      <template #content>
        <!-- CONFIGURAÇÕES INTERNAS -->
        <PmwAccordion class="accordion">
          <PmwAccordionItem
            :defaultTitle="false"
            description=""
            title="Configurações Internas"
            class="accordion--item"
            @open="showSettingsForm = true"
          >
            <template #content>
              <InternalSettingsForm
                v-model="internalSettings"
                :isOpen="showSettingsForm"
                :hotelPms="hotelPms"
                :rooms="rooms"
                :tipoPensao="tipoPensao"
                @selectedRooms="internalSettingsInput"
                @tipoPensaoValue="updateTipoPensao"
              />
            </template>
          </PmwAccordionItem>
        </PmwAccordion>

        <!-- PRECIFICAÇÃO -->
        <PmwAccordion class="accordion">
          <PmwAccordionItem
            :defaultTitle="false"
            description=""
            title="Precificação"
            class="accordion--item"
            @open="showPricingForm = true"
          >
            <template #content>
              <PricingForm
                :fluctuationData="pricingSettings"
                :isOpen="showPricingForm"
                :rooms="rooms"
                :coefficientType="coefficientType"
                :isRateAbsolute="isRateAbsolute"
                @hasAllFields="hasAllFields"
              />
            </template>
          </PmwAccordionItem>
        </PmwAccordion>

        <!-- PERÍODOS -->
        <PmwAccordion class="accordion">
          <PmwAccordionItem
            :defaultTitle="false"
            description=""
            title="Períodos"
            class="accordion--item"
            @open="showPeriodsForm = true"
          >
            <template #content>
              <PeriodsForm v-model="periodSettings" :isOpen="showPeriodsForm" />
            </template>
          </PmwAccordionItem>
        </PmwAccordion>

        <!-- ALLOTMENT POR ACOMODAÇÃO -->
        <PmwAccordion class="accordion">
          <PmwAccordionItem
            :defaultTitle="false"
            description=""
            title="Allotment por acomodação"
            class="accordion--item"
            @open="showAllotmentForm = true"
          >
            <template #content>
              <AllotmentForm
                v-model="allotmentSettings"
                :allHotelRooms="rooms"
                :isOpen="showAllotmentForm"
              />
            </template>
          </PmwAccordionItem>
        </PmwAccordion>

        <div class="footer">
          <PmwButton
            variation="blue-100"
            layout="outline"
            class="footer--button"
            @click="$router.push(`/hoteis/regras-tarifarias/${hotelId}`)"
          >
            Voltar sem salvar
          </PmwButton>

          <PmwButton
            :disabled="disableSave"
            tooltipText="Para salvar, preencha todos os valores do quarto editado"
            variation="blue-100"
            class="footer--button"
            @click="saveRate"
          >
            Salvar
          </PmwButton>
        </div>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
import { hotelRateValues } from '@/helpers/masterRates.js'
import InternalSettingsForm from '@/components/hotel/masterRates/InternalSettingsForm'
import PricingForm from '@/components/hotel/masterRates/PricingForm'
import PeriodsForm from '@/components/hotel/masterRates/PeriodsForm'
import AllotmentForm from '@/components/hotel/masterRates/AllotmentForm'
import PmwAccordion from '@solucoes/components-lib-tmp/src/components/patterns/PmwAccordion'
import PmwAccordionItem from '@solucoes/components-lib-tmp/src/components/patterns/PmwAccordion/PmwAccordionItem'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwTopProgress from '@solucoes/components-lib-tmp/src/components/elements/PmwTopProgress'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import SidebarLayout2 from '@/layouts/SidebarLayout2'

export default {
  name: 'MasterRate',

  components: {
    InternalSettingsForm,
    PricingForm,
    PeriodsForm,
    AllotmentForm,
    PmwAccordion,
    PmwAccordionItem,
    PmwButton,
    PmwParagraph,
    PmwTopProgress,
    SidebarBlock,
    SidebarLayout2
  },

  data() {
    return {
      breadcrumb: [
        {
          label: 'Letsbook',
          url: '',
          isSpa: false
        },
        {
          label: 'Hotéis',
          url: '/hoteis',
          isSpa: true
        },
        {
          label: '',
          url: `/hoteis/editar/${this.$route.params.id}`,
          isSpa: true
        },
        {
          label: 'Regras tarifárias',
          url: `/hoteis/regras-tarifarias/${this.$route.params.id}`,
          isSpa: true
        },
        {
          label: 'Criar regra',
          url: '',
          isSpa: false
        }
      ],

      hotelName: 'Nome do hotel',

      hotelId: '',

      rateId: '',

      hotelPms: '',

      rooms: [],

      coefficientType: 0,

      isRateAbsolute: false,

      internalSettings: hotelRateValues().settings,

      pricingSettings: hotelRateValues().pricing,

      periodSettings: hotelRateValues().periods,

      allotmentSettings: hotelRateValues().allotment,

      showSettingsForm: false,

      showPricingForm: false,

      showPeriodsForm: false,

      showAllotmentForm: false,

      masterRate: null,

      loading: false,

      noErrors: true,

      tipoPensao: 1
    }
  },

  async created() {
    this.loading = true
    this.hotelId = this.$route.params.id
    this.rateId = this.$route.params.rateId

    await this.getHotel()
    await this.getRooms()
    this.getRate()
  },

  computed: {
    disableSave() {
      return !this.noErrors || this.loading
    }
  },

  methods: {
    /**
     * Atualiza o valor de tipoPensao com o novo valor selecionado
     * @param {number} value: Novo valor de tipoPensao selecionado
     */
    updateTipoPensao(value) {
      this.tipoPensao = value
    },

    /**
     * Verifica se todos os campos obrigatórios estão preenchidos
     * @param {boolean} event: se tem algum campo obrigatório vazio
     */
    hasAllFields(event) {
      this.noErrors = event
    },
    /**
     * Passa os ids dos quartos selecionados para o componente de allotment
     * @param {array} event: array com os ids dos quartos selecionados
     */
    internalSettingsInput(event) {
      this.allotmentSettings.quartos = event
      this.pricingSettings.quartos = event
    },

    getHotel() {
      this.$hotel.get(this.hotelId).then((response) => {
        const data = response.data

        this.hotelName = data.nome

        this.breadcrumb[2].label = this.hotelName

        this.hotelPms = data.pms
        this.isRateAbsolute = data.tarifarioAbsoluto
      })
    },

    async getRooms() {
      await this.$room.get(this.hotelId, true).then((response) => {
        this.rooms = response.data.map((item) => {
          return {
            ...item
          }
        })
      })
    },

    getRate() {
      this.$rate.getRuleRate(this.rateId).then((response) => {
        this.breadcrumb[4].label = `Editando ${response.data.nome}`
        this.tipoPensao = response.data.tipoPensao
        this.masterRate = response.data.codigoTarifaMaster
        this.coefficientType = response.data.tipoCoeficiente

        this.setInternalSettingsData(response.data)
        this.setPricingSettings(response.data)
        this.setPeriodSettings(response.data)
        this.setAllotmentSettings(response.data)
        this.loading = false
      })
    },

    /**
     * Separa os dados de configurações internas para passar para o componente
     * @param {object} data: dados da tarifa
     */
    setInternalSettingsData(data) {
      for (const key in this.internalSettings) {
        this.internalSettings[key] = data[key]
      }

      if (this.internalSettings.quartos === null) {
        this.internalSettings.quartos = []
      }
    },

    /**
     * Separa os dados de precificação para passar para o componente
     * @param {object} data: dados da tarifa
     */
    setPricingSettings(data) {
      for (const key in this.pricingSettings) {
        if (data[key]) {
          this.pricingSettings[key] = data[key]
        }
      }
    },

    /**
     * Separa os dados de períodos para passar para o componente
     * @param {object} data: dados da tarifa
     */
    setPeriodSettings(data) {
      for (const key in this.periodSettings) {
        this.periodSettings[key] = data[key]
      }
    },

    /**
     * Separa os dados de allotment para passar para o componente
     * @param {object} data: dados da tarifa
     */
    setAllotmentSettings(data) {
      this.allotmentSettings.allotmentQuartos = data.allotmentQuartos
      this.allotmentSettings.quartos = data.quartos
    },

    /** Atualiza a tarifa */
    saveRate() {
      this.loading = true
      const params = this.standarizeDataToSave()
      this.$rate
        .editRuleRate(params)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Tarifa atualizada com sucesso.'
          })

          this.$router.push({
            path: `/hoteis/regras-tarifarias/${this.hotelId}`
          })
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     *  Organiza os dados para salvar
     * @returns objeto com os dados padronizados
     */
    standarizeDataToSave() {
      const obj = {}

      for (const key in this.internalSettings) {
        if (this.internalSettings[key]) {
          obj[key] = this.internalSettings[key]
        }
      }

      const pricingObj = this.standarizePricingDataToSave(this.pricingSettings)

      for (const key in pricingObj) {
        obj[key] = pricingObj[key]
      }

      if (
        this.periodSettings.periodosBlackout &&
        this.periodSettings.periodosBlackout.length
      ) {
        obj['periodosBlackout'] = this.periodSettings.periodosBlackout
      }

      if (this.periodSettings.dataInicioPeriodoDestaque !== null) {
        obj[
          'dataInicioPeriodoDestaque'
        ] = this.periodSettings.dataInicioPeriodoDestaque
        obj[
          'dataFimPeriodoDestaque'
        ] = this.periodSettings.dataFimPeriodoDestaque
      }

      obj['tipoPensao'] = this.tipoPensao

      obj['pacoteFechado'] = this.periodSettings.pacoteFechado

      const allotmentObj = this.validateAllotmentFields(
        this.allotmentSettings.allotmentQuartos
      )

      if (allotmentObj.length) {
        obj['allotmentQuartos'] = allotmentObj
      }

      return obj
    },

    /** Desvincula uma tarifa da tarifa master */
    unlinkMasterRate() {
      this.loading = true

      const codigoFlutuacao = this.internalSettings.codigo

      this.$rate
        .unlinkMasterRate(codigoFlutuacao)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Tarifa desvinculada com sucesso.'
          })
          this.loading = false
          this.$router.push({
            path: `/hoteis/regras-tarifarias/${this.hotelId}`
          })
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
          this.loading = false
        })
    },

    /**
     * Organiza os dados de precificação e remove os campos vazios
     * @param {object} pricingValues: objeto com todos os dados de precificação
     * @returns objeto com apenas os dados preenchidos
     */
    standarizePricingDataToSave(pricingValues) {
      const obj = {}

      if (pricingValues.pensoes.length) {
        obj['pensoes'] = this.validatePensionFields(pricingValues.pensoes)
      }

      if (pricingValues.diferenciaisPax.length) {
        obj['diferenciaisPax'] = pricingValues.diferenciaisPax.filter(
          (item) => item.valorAdicional !== null && item.valorAdicional !== ''
        )
      }

      if (pricingValues.diferenciaisQuartos.length) {
        obj[
          'diferenciaisQuartos'
        ] = pricingValues.diferenciaisQuartos.filter((quarto) =>
          Object.values(quarto).every((value) => value !== null)
        )
      }

      if (pricingValues.precosQuartos.length) {
        obj['precosQuartos'] = this.validateRoomPrices(
          pricingValues.precosQuartos
        )
      }

      obj['codigoTarifaBase'] = pricingValues.codigoTarifaBase
      obj['tipoFlutuacao'] = pricingValues.tipoFlutuacao
      obj['tipoCoeficiente'] = pricingValues.tipoCoeficiente

      return obj
    },

    /**
     * Valida os campos preenchidos de pensoes que foram preenchidos
     * @param {array} pensionArray: todos os campos de pensões
     * @returns array apenas com os campos que tem dados preenchidos
     */
    validatePensionFields(pensionArray) {
      return pensionArray?.filter((item) => {
        return (
          (item.valorCafe !== null && item.valorCafe !== '') ||
          (item.valorAlmoco !== null && item.valorAlmoco !== '') ||
          (item.valorJanta !== null && item.valorJanta !== '') ||
          (item.valorTotal !== null && item.valorTotal !== '')
        )
      })
    },

    /**
     * Valida os campos preenchidos de allotment por acomodação
     * @param {array} allotmentArray: todos os campos de allotment
     * @returns array apenas com os campos preenchidos
     */
    validateAllotmentFields(allotmentArray) {
      return allotmentArray.filter(
        (item) => item.allotment !== null && item.allotment !== ''
      )
    },

    /**
     * Valida os campos de precosQuartos com valores
     * @returns array apenas com os itens que tem dados
     */
    validateRoomPrices(roomsPrices) {
      return roomsPrices.filter(
        (item) =>
          item.valoresOcupantes.length > 0 &&
          item.valoresOcupantes.every((array) => array.valor !== '')
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  &-panel {
    background-color: pmw-colors('blue-100');
    color: white;
    height: 160px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 0;
  }

  &-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    &--title {
      margin-bottom: 5px;
    }
  }

  &-tip {
    &--title {
      color: pmw-colors('red-100');
      margin-bottom: 10px;
    }
    &--link {
      color: pmw-colors('blue-100');
      &:hover {
        text-decoration: underline;
        color: pmw-colors('blue-100');
      }
    }
  }
}

.warning {
  background-color: pmw-colors('red-80');
  width: 100%;
  display: flex;
  margin-bottom: -18px;
  margin-top: 20px;
  color: white;
  padding: 13px;
  justify-content: center;
  &--text {
    display: flex;
    gap: 5px;
    &__link {
      text-decoration: underline;
      font-weight: 700;
    }
  }
}

.accordion {
  background-color: inherit;
  padding: 15px;
  width: 100%;
  border-radius: 4px;
  margin-top: 45px;
  @include pmw-box-shadow(0 8px 25px rgba(0, 0, 0, 0.1));

  &--item {
    padding: 15px;
  }
}

.footer {
  display: flex;
  justify-content: space-between;
  margin-top: 45px;
  &--button {
    width: 214px;
  }
}

::v-deep {
  .lb-breadcrumb--link:nth-child(2) {
    cursor: default;
    pointer-events: none;
  }
  .content--white_card .page-heading {
    padding-bottom: 0;
  }

  .pmw-form-field {
    &--label {
      font-weight: pmw-font-weight('weight-medium');
    }
  }

  .pmw-input-checkbox {
    &--fakebox {
      .pmw-icon {
        color: pmw-colors('blue-100');
      }
    }
    input {
      &:checked ~ .pmw-input-checkbox--fakebox {
        background-color: pmw-colors('blue-100');
        border: 1px solid pmw-colors('blue-100');
      }
    }
  }

  .pmw-input {
    background: inherit;
    &__focus {
      border-color: pmw-colors('blue-100');
    }
    &--field {
      &:focus {
        border-color: pmw-colors('blue-100');
      }
    }
    &--clear {
      color: pmw-colors('blue-100');
    }
  }

  .pmw-select {
    &-options {
      background-color: white;
      &--item {
        &__checked,
        &__hover:hover {
          background-color: pmw-colors('blue-100') !important;
        }
      }
    }
    &--button {
      padding: 0;
      &:focus {
        border-color: pmw-colors('blue-100');
      }

      &__show {
        border-bottom-color: pmw-colors('blue-100');
      }
    }

    .search-input__focus {
      border-color: pmw-colors('blue-100');
    }
  }
}
</style>
